import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const DocumentCategoryDetails = (props) => {
  const history = useHistory();
  const { documentCategory } = props.location.state;

  return (
    <>
      <Navbar />
      <div className="cust-div" style={{ minHeight: "550px" }}>
        <div className="container mx-auto mt-8 p-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl   font-bold">Category Details</h1>
            <div>
              <button
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 mr-3 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"
                onClick={() => history.goBack()}
              >
                <i
                  className="fa fa-arrow-circle-left mr-1"
                  title="Go To Documents Category"
                ></i>
              </button>
            </div>
          </div>
          <div>
            <div>
              <strong>Category Name:</strong> {documentCategory.name}
            </div>
            <div>
              <strong>Default Text:</strong> {documentCategory.defaultText}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DocumentCategoryDetails;
